angular.module('zc.zenclerkS')
  .controller('ZcsAgencySettingsController', ZcsAgencySettingsController);

ZcsAgencySettingsController.$inject = ['Agency', 'agency'];
function ZcsAgencySettingsController(Agency, agency) {
  const vm = this;
  vm.agency = agency;

  vm.save = updatedAgency => Agency.update(updatedAgency);
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/settings/agency_settings.controller.js